import { QUESTION_CATEGORY_SUBSCRIBE_POLICY_EVERYONE, QUESTION_CATEGORY_VISIBILITY_SUBSCRIBED } from '../../constants/quests';

export const isQuestionCategorySubscribable = function (cat) {
    return cat && ((cat.visibility == QUESTION_CATEGORY_VISIBILITY_SUBSCRIBED && cat.subscribe_policy == QUESTION_CATEGORY_SUBSCRIBE_POLICY_EVERYONE) || cat.subscribed);
};
